<div class="choose_size_guide_cont">
	<div class="inner_choose_size_guide_cont">
		<button class="a-close-btn" (click)="closeSlider()">
			<span class="material-symbols-outlined">
				close
			</span>
		</button>

		<h1 class="a-fabric-heading"><span *ngIf="!isFabricProduct">SIZE</span> GUIDE</h1>

		<p class="a-fabric-disclaimer">
			Disclaimer: {{sizeDataPassOne.disclaimer}}
		</p>

		<ng-container *ngIf="!isFabricProduct">
			<label class="switch">
				<input type="checkbox" [checked]="inCm" (change)="sizeMetrics()">
				<span class="slider {{inCm?'cm':'in'}}">
					<span class="a-cm">in</span><span class="a-inch">cm</span>
				</span>
			</label>

			<div class="a-size-table">
				<!-- <table *ngIf="productData"> -->
				<table>
					<tr>
						<th></th>
						<ng-container *ngFor="let label of sizeDataPassOne.sizeProfileOptionList; let i = index">
							<th>
								{{label.label}}
							</th>
						</ng-container>
					</tr>
					<ng-container *ngFor="let size of newSizeArray">
						<tr>
							<td>{{size.guide}}</td>
							<ng-container *ngFor="let number of size.guideNumber">
								<td>
									{{inCm ?  (number * 2.54).toFixed() : number.toFixed() }}
								</td>
							</ng-container>
						</tr>
					</ng-container>
				</table>
			</div>
		</ng-container>

		<img class="a-size-img" src="{{sizeDataPassOne.image}}" alt="size guide image">
	</div>
</div>
<div class="overlay_pop_up_pd" (click)="closeSlider()"></div>
